<template>
  <yxtbiz-group-org-select
    :placeholder="$t('pc_biz_chooseOrgId' /* 请选择可以观看直播的平台 */)"
    @change="change"
    multiple
    :selected.sync="value"
    functionCode="group_task_center"
    dataPermissionCode="task_manage_platform"
  ></yxtbiz-group-org-select>
</template>
<script>
export default {
  name: 'LiveOpenRange',
  props: {
    value: {
      type: Array,
      default: []
    }
  },
  methods: {
    change(orgInfo) {
      this.$emit('input', orgInfo);
    }
  }
};
</script>
<style scoped lang="less"></style>
